import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgFirmnessGlyphSecondary from './svgs/FirmnessGlyphSecondary.js';
import SvgFirmnessGlyph from './svgs/FirmnessGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var firmnessGlyph = (props => useIcon(SvgFirmnessGlyph, SvgFirmnessGlyphSecondary, props));

export { firmnessGlyph as default };
